import { SortingOrder } from "../../models";
import {
  VerwerkingsoverzichtFilter,
  VerwerkingsoverzichtResultaat,
  VerwerkingsStatus,
} from "../../models/verwerkingsoverzicht";
import { IVerwerkingsoverzichtApi } from "../verwerkingsoverzicht";

export class MockVerwerkingsoverzichtApi implements IVerwerkingsoverzichtApi {
  getVerwerkingsoverzicht = async (
    start: number,
    pagesize: number,
    _order?: SortingOrder,
    _filters?: VerwerkingsoverzichtFilter[]
  ) => {
    // return Promise.reject(new Error("Error creating metadata session"));
    if (start !== undefined && start < 0) throw new Error("Ongeldige pagina");
    const resultaten = alleVerwerkingsoverzichtResultaten.slice(start, start + pagesize);
    return {
      totaal: alleVerwerkingsoverzichtResultaten.length,
      start,
      aantal: resultaten.length,
      resultaten,
    };
  };
}

interface VerwerkingsoverzichtMockTemplate {
  id: string;
  titel: string;
  status: VerwerkingsStatus;
  foutInformatie?: string[];
}

const verwerkingsoverzichtMockTemplates: VerwerkingsoverzichtMockTemplate[] = [
  {
    id: "8eb8d14e-f09f-45a9-bda7-47b55d8ff2c2",
    titel:
      "Document met meerdere regels en veel regels door lange titel zoals deze lang 1 2 3 4 5 6 7 8 9 1 2 3 4 5 6 7 8 9 1 2 3 4 5 6 7 8 9.",
    status: "fout",
    foutInformatie: [
      "Het document kan niet worden opgehaald via de opgegeven link. Controleer de link en probeer het opnieuw.",
    ],
  },
  {
    id: "6944e6db-8a2a-4881-a958-f4363820703b",
    titel: "Document met meerdere regels en veel regels door lange titel zoals deze lang...",
    status: "fout",
    foutInformatie: ["Er is een technische fout opgetreden. Neem contact op met de servicedesk (woo@logius.nl)"],
  },
  {
    id: "78893370-ac1f-4933-9b46-ec7a5916faaa",
    titel: "Bijlage met meerdere regels en veel regels door lange titel zoals deze lang...",
    status: "fout",
    foutInformatie: ["Het bestand is te groot (maximaal 1 GB). Verklein het bestand en probeer het opnieuw."],
  },
  {
    id: "b38b3131-d797-4948-89c3-31b1319a23a5",
    titel: "Document met meerdere regels en veel regels door lange titel zoals deze lang...",
    status: "in_verwerking",
  },
  {
    id: "55629665-cc95-40c0-8000-1e74bb221f99",
    titel: "Document met meerdere regels en veel regels door lange titel zoals deze lang...",
    status: "fout",
    foutInformatie: [
      "Het bestand is niet veilig. Controleer het met een virusscanner en upload het opnieuw. Blijft dit gebeuren? Neem contact op met de servicedesk (woo@logius.nl)",
    ],
  },
  {
    id: "c71e3468-a1dd-4554-bc89-cd541f901e8c",
    titel: "Document met meerdere regels en veel regels door lange titel zoals deze lang...",
    status: "fout",
    foutInformatie: ["Het bestandstype is niet toegestaan. Alleen ZIP- en PDF-bestanden zijn toegestaan."],
  },
];

const TOTAAL_AANTAL_MOCK_RESULTATEN = 30;

const alleVerwerkingsoverzichtResultaten: VerwerkingsoverzichtResultaat[] = Array.from(
  { length: TOTAAL_AANTAL_MOCK_RESULTATEN },
  (_, index): VerwerkingsoverzichtResultaat => {
    const template = verwerkingsoverzichtMockTemplates[index % verwerkingsoverzichtMockTemplates.length];
    const id = `${template.id}-${index}`;

    return {
      id,
      pid: `https://open.overheid.nl/documenten/${id}`,
      aanleverdatumtijd: "2024-01-01T15:28:00Z",
      mutatiedatumtijd: "2024-01-01T15:28:00Z",
      identifiers: ["2024-1235069483"],
      titelcollectie: { officieleTitel: template.titel },
      publisher: { id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034", label: "EZK" },
      verwerkingsstatus: {
        laatsteVerwerking: {
          status: template.status,
          tijdstipLaatsteWijziging: "2024-01-01T15:28:00Z",
          ...(template.foutInformatie ? { foutInformatie: template.foutInformatie } : {}),
        },
      },
    };
  }
);
